import * as React from 'react';

function SvgRoleLandlord(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 41 41" {...props}>
      <g fill="#38B2A6">
        <path d="M27.5 21.534l.023 1.002-5.62 5.672-.001 12.557h-5.836c-3.102 0-8.188-.016-10.114-.235 0 0-5.949-.235-5.949-4.114 0 0-.235-5.736 3.433-9.85l.036-.045c.406-.499 4.235-4.987 10.498-4.987H27.5zM18.085 0c5.502 0 9.851 4.35 9.851 9.85 0 5.267-4.35 9.85-9.851 9.85-5.502 0-9.852-4.348-9.852-9.85 0-5.5 4.35-9.85 9.852-9.85z" />
        <path d="M24 30.107L32.435 21 41 30.107V40h-5.963v-4.953h-4.982V40H24z" />
      </g>
    </svg>
  );
}

export default SvgRoleLandlord;
